var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'h5-header': !Boolean(_vm.statusBarHeight)},style:({height: _vm.headerHeight, background:'#fff'})})}
var staticRenderFns = []

export { render, staticRenderFns }